interface Article {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  content: string;
}

interface ArticleModalProps {
  article: Article;
  onClose: () => void;
}

export default function ArticleModal({ article, onClose }: ArticleModalProps) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl max-w-4xl w-full my-8 shadow-2xl">
        <div className="relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer shadow-lg"
          >
            <i className="ri-close-line text-2xl text-gray-700 w-6 h-6 flex items-center justify-center"></i>
          </button>

          <div className="relative h-80 w-full overflow-hidden rounded-t-2xl">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <span className="inline-block px-4 py-1.5 bg-emerald-600 text-white text-xs font-semibold rounded-full mb-3">
                {article.category}
              </span>
              <h2 className="text-3xl font-bold text-white mb-3">{article.title}</h2>
              <div className="flex items-center gap-4 text-white/90 text-sm">
                <span className="flex items-center gap-2">
                  <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                  {article.readTime}
                </span>
              </div>
            </div>
          </div>

          <div className="p-8 max-h-[60vh] overflow-y-auto">
            <div className="prose prose-lg max-w-none">
              <div className="text-gray-700 leading-relaxed space-y-4">
                {article.content.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-base">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <button className="flex items-center gap-2 px-4 py-2 bg-emerald-50 text-emerald-700 rounded-lg hover:bg-emerald-100 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-heart-line text-lg w-5 h-5 flex items-center justify-center"></i>
                    Like
                  </button>
                  <button className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-share-line text-lg w-5 h-5 flex items-center justify-center"></i>
                    Share
                  </button>
                </div>
                <button
                  onClick={onClose}
                  className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap font-medium"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
